<template>
    <header class="cabinet-header">
        <nav class="navbar">
            <div class="container-fluid">
                <div class="d-flex align-items-center w-100">
                    <div class="nav-title d-flex align-items-center gap-3">
                        <a class="back-to-cabinet" href="https://cabinet.superqr.com/cabinet">
                            <i class="bi bi-arrow-left-circle me-2"></i>{{ $t('navbar.backToCabinet') }}
                        </a>
                        <h5 v-if="title" class="mb-0">{{ title }}</h5>
                    </div>
                    <div class="ms-auto d-flex align-items-center gap-3">
                        <div class="dropdown lang-switcher">
                            <button class="btn btn-sm btn-light dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                {{ currentLocaleLabel }}
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                                <li v-for="loc in locales" :key="loc.code">
                                    <a class="dropdown-item" href="#" :class="{ active: locale === loc.code }" @click.prevent="changeLocale(loc.code)">{{ loc.label }}</a>
                                </li>
                            </ul>
                        </div>
                        <span class="nav-email d-none d-md-block">{{ fullName }}</span>
                        <span class="username-avatar">{{ shortName }}</span>
                    </div>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
import i18n, { setLocale } from '../i18n'

export default {
    data:() => ({
        shortName: '',
        fullName: '',
        locales: [
            { code: 'ru', label: 'RU' },
            { code: 'kz', label: 'KZ' },
            { code: 'en', label: 'EN' },
            { code: 'zh', label: '中' }
        ]
    }),
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    computed: {
        locale() {
            return i18n.global.locale.value
        },
        currentLocaleLabel() {
            return this.locales.find(l => l.code === this.locale)?.label ?? 'RU'
        }
    },
    async mounted() {
        await this.getShortName()
    },
    methods: {
        changeLocale(code) {
            setLocale(code)
        },
        async getShortName() {
            let r = await this.$api.getUser()
            if(r.result === 'SUCCESS') {
                this.fullName = r.data.username
                this.shortName = r.data.username.slice(0, 2).toUpperCase()
            }
        }
    }
}
</script>

<style scoped>
.container-fluid {
    padding: 0 2em;
}

.navbar {
    padding: 0;
    height: 64px;
}

.nav-title h5 {
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
}

.nav-email {
    font-size: 13px;
    color: var(--text-secondary);
}

.back-to-cabinet {
    display: inline-flex;
    align-items: center;
    font-size: 13px;
    font-weight: 500;
    color: var(--primary-color);
    text-decoration: none;
    transition: var(--default-transition);
}

.back-to-cabinet:hover {
    opacity: 0.8;
}

.username-avatar {
    display: flex;
    width: 36px;
    height: 36px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-image: var(--main-gradient);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
}

.lang-switcher .btn {
    font-weight: 600;
    border-color: var(--border-color);
}
</style>
